import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@lib/api";
import { type AutoTranslateLanguage } from "../types/StoryblokTypes";

export type { AutoTranslateLanguage };

// TODO: generate types from OpenAPI spec
export interface App {
  id: string;
  label: string;
  linkUrl: string;
  logoUrl: string;
  appName: string;
  appInstanceId: string;
  appAssignmentId: string;
  credentialsSetup: boolean;
  hidden: boolean;
  sortOrder: number;
}

export interface User {
  id: number;
  apps: App[];
  languagePreference: "nl" | "en";
  themePreference: "light" | "dark" | "system";
  filterPreference?: string[];
  isLeader?: boolean;
  autoTranslateEnabled: boolean;
  autoTranslateLanguage: AutoTranslateLanguage | null;
}

export interface FinishedWalkthrough {
  walkthroughId: number;
  isOnboarding: boolean;
  createdAt: string;
}

export interface UserData {
  user: User;
  finishedWalkthroughs?: FinishedWalkthrough[];
}
export const QUERY_KEY = "getUser";

// TODO set type based on OpenAPI type definition
export const fetchUser = async (): Promise<UserData> => {
  const response = await apiClient.get<UserData>("/api/v1/user", {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export const useGetUser = () => {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: fetchUser,
    select: (
      data: UserData
    ): { user: User; finishedWalkthroughs: FinishedWalkthrough[] } => {
      return {
        user: data.user,
        finishedWalkthroughs: data.finishedWalkthroughs || [],
      };
    },
  });
};
